import { Router } from '@angular/router';
import frenchi18n from '@assets/i18n/fr.json';
import { StoreService } from '@shared/services/store.service';
import { TrackerService } from '@shared/services/tracker.service';

export class ErrorVM {
  constructor(
    private tracker: TrackerService,
    private storeService: StoreService,
    private router: Router
  ) {
    const routerExtras = this.router?.getCurrentNavigation()?.extras;

    const shouldTagErrorPage = routerExtras?.state && 'isWrongUrl' in routerExtras.state;
    this.storeService.setVariable('SHOULD_TAG_ERROR_PAGE', shouldTagErrorPage ?? false);
  }

  async onInit(): Promise<void> {
    this.preventBrowserBackNavigation();

    // We don't tag when user manipulate URL or when refresh /error page
    const shouldTagErrorPage = this.storeService.getVariableOrThrow('SHOULD_TAG_ERROR_PAGE');

    const errorPageOrigin = this.storeService.getVariable('PROCESS_PAGE') ?? 'UNKNOWN_PAGE_ORIGIN';

    if (!shouldTagErrorPage) {
      return;
    }

    const taggingInitData = this.storeService.getVariable('TAGGING_INIT_DATA_IN_BASE64');
    if (taggingInitData) {
      await this.tracker.initializeTaggingTracker(taggingInitData);

      const userId = this.storeService.getVariable('USER_ID') || 'USER_ID_NOT_DEFINED';
      this.tracker.trackPageError({
        taggingPage: 'ERROR',
        errorPageOrigin,
        userId,
      });
    }
  }

  continue() {
    this.tracker.trackClick({ taggingPage: 'ERROR', click: frenchi18n.continue_my_request });
    this.storeService.reset();
    window.parent.postMessage('ERROR', '*');
  }

  private preventBrowserBackNavigation() {
    history.replaceState(null, '', '/error');
    history.pushState(null, '', '/error');
  }
}
